<div mat-dialog-title>
  @if (data.icon) {
    <mat-icon [svgIcon]="data.icon"></mat-icon>
  }
  @if (data.title) {
    <h2>{{data.title}}</h2>
  }
</div>
<mat-dialog-content>
  @if (data.version) {
    <div class="m-bottom">Version: {{data.version}}</div>
  }
  @if (data.releaseDate) {
    <div class="m-bottom">Release Date: {{data.releaseDate | date: 'longDate'}}</div>
  }
  @if (data.isCookieModal) {
    <p><a class="terms" (click)="openCookieModal('terms')"><u>OSC Terms of Use</u></a> | <a class="privacy"
    (click)="openCookieModal('privacy')"><u>OSC Privacy Notice</u></a> | <a class="cookie"
    (click)="openCookieModal('cookie')"><u>OSC Cookie Notice</u></a></p>
  } @else {
    @if (data.content) {
      <div [innerHTML]="data.content"></div>
    }
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button (click)="dialogRef.close()" type="button">{{ 'aboutModalComponent.close' | translate }}</button>
</mat-dialog-actions>
<div class="app-store__container">
  <a href="pdfUrl" width="100%" height="600px"></a>
</div>